function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Link, useParams } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import Footer from "../components/Footer";
import { Button, Alert, notification, Result, Skeleton, Modal } from 'antd';
import Common from "../components/includes/Common";
import { HourglassSplit, Stopwatch } from 'react-bootstrap-icons';
import Vote from "./Vote";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var VoteResponse = function VoteResponse() {
  var _useParams = useParams(),
    orderid = _useParams.orderid;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    transactionStatus = _useState2[0],
    setTransactionStatus = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    dataLoading = _useState4[0],
    setDataLoading = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    showVote = _useState6[0],
    setShowVote = _useState6[1];
  useEffect(function () {
    if (orderid) {
      setDataLoading(true);
      axios.get(Common.baseApiUrl + 'getvotetransactionstatus/' + orderid).then(function (response) {
        setTransactionStatus(response.data.status);
      })["catch"](function (e) {
        notification.error({
          message: "Erreur",
          description: "Impossible de verifier la transaction"
        });
      })["finally"](function () {
        setDataLoading(false);
      });
    }
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Vote, {}), /*#__PURE__*/_jsx(Modal, {
      footer: null,
      title: /*#__PURE__*/_jsx("b", {
        children: "Infos !"
      }),
      open: showVote,
      destroyOnClose: true,
      centered: true,
      onCancel: function onCancel() {
        setShowVote(false);
      },
      width: {
        xs: '95%',
        sm: '80%',
        md: '70%',
        lg: '60%',
        xl: '40%',
        xxl: '40%'
      },
      children: !dataLoading ? /*#__PURE__*/_jsxs("div", {
        className: "s-box  white-bg",
        children: [transactionStatus == 1 && /*#__PURE__*/_jsx(Result, {
          status: "success",
          title: "Paiement \xE9ffectu\xE9 avec succ\xE8s !",
          subTitle: "Plus vous votez, plus vous augmentez les chances de votre candidat(e)",
          extra: [/*#__PURE__*/_jsx(Button, {
            type: "default",
            onClick: function onClick() {
              setShowVote(false);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: "CONTINUER"
            })
          })]
        }), transactionStatus == 2 && /*#__PURE__*/_jsx(Result, {
          status: "error",
          title: "Echec du paiement!",
          subTitle: "Veuillez essayer encore",
          extra: [/*#__PURE__*/_jsx(Button, {
            type: "default",
            onClick: function onClick() {
              setShowVote(false);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: "CONTINUER"
            })
          })]
        }), transactionStatus == 0 && /*#__PURE__*/_jsx(Result, {
          icon: /*#__PURE__*/_jsx(HourglassSplit, {}),
          title: "Paiement en cours ...",
          subTitle: "Votre paiement est en cours de traitement ...",
          extra: [/*#__PURE__*/_jsx(Button, {
            type: "default",
            onClick: function onClick() {
              setShowVote(false);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: "CONTINUER"
            })
          })]
        }), transactionStatus == 3 && /*#__PURE__*/_jsx(Result, {
          icon: /*#__PURE__*/_jsx(Stopwatch, {}),
          title: "Transaction expir\xE9e",
          subTitle: "Trop tard... La transaction a expir\xE9, veuillez essayer encore ...",
          extra: [/*#__PURE__*/_jsx(Button, {
            type: "default",
            onClick: function onClick() {
              setShowVote(false);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: "CONTINUER"
            })
          })]
        })]
      }) : /*#__PURE__*/_jsx(Skeleton, {
        active: true
      })
    })]
  });
};
export default VoteResponse;